import styled, { css } from 'styled-components';

export const Wrapper = styled.section<{ $isLoading: boolean }>`
    height: 100vh;

    @keyframes skeleton {
        0%,
        100% {
            opacity: 0.3;
        }

        50% {
            opacity: 0.1;
        }
    }

    ${({ $isLoading, theme }) =>
        $isLoading
            ? css`
                  background: ${theme.colors.skeleton02};
                  opacity: 1;
                  animation: skeleton 1.5s infinite;
                  > * {
                      visibility: hidden;
                  }
              `
            : css``}
`;
